// 1. Определяем, что может прийти от сервера
interface WindowConfig {
	game?: string;
	forcedAdapter?: string;
	routerBasePath?: string;
	apiBasePath?: string;
	routerType?: "HashRouter" | "BrowserRouter";
	supportedLocales?: string[];
	defaultLocale?: string;
}

declare global {
	interface Window {
		FX_CONFIG?: WindowConfig;
	}
	// Для WeChat и других non-browser окружений
	var FX_CONFIG: WindowConfig | undefined;
}

// ВНИМАНИЕ! Должно совпадать с C# объектом GetIndexHtmlForGame::
interface AppConfig {
	game?: string;
	forcedAdapter?: string;
	routerBasePath: string;
	apiBasePath: string;
	routerType: "HashRouter" | "BrowserRouter";
	normalizedBaseUrl: string;
	supportedLocales: string[];
	defaultLocale: string;
}

export const hardcodedDefaultLocale = "en";

export const hardcodedDefaultSupportedLocales = [
	"en",
	"de",
	"es",
	"fa",
	"fr",
	"it",
	"ja",
	"ko",
	"pt-br",
	"ru",
	"tr",
	"zh",
	"uk",
	"pl"
];


// 2. Читаем конфигурацию из window/global, если она есть
// Поддерживаем как browser (window), так и non-browser окружения (globalThis)
const windowConfig = (typeof window !== 'undefined' ? window.FX_CONFIG : globalThis.FX_CONFIG) || {};

// Безопасное получение переменных окружения
// Vite заменяет import.meta.env.X на строки во время сборки
// Обрабатываем каждую переменную отдельно с try-catch для WeChat совместимости
let VITE_APP_BUILD_MODE: string | undefined;
let VITE_APP_ROUTER_BASEPATH: string | undefined;
let VITE_APP_API_BASE_PATH: string | undefined;
let BASE_URL = "/";

try {
	if (typeof import.meta !== 'undefined' && import.meta.env) {
		VITE_APP_BUILD_MODE = import.meta.env.VITE_APP_BUILD_MODE;
		VITE_APP_ROUTER_BASEPATH = import.meta.env.VITE_APP_ROUTER_BASEPATH;
		VITE_APP_API_BASE_PATH = import.meta.env.VITE_APP_API_BASE_PATH;
		BASE_URL = import.meta.env.BASE_URL ?? "/";
	}
} catch (e) {
	// В WeChat import.meta может не работать - используем значения по умолчанию
}

// 3. Определяем routerBasePath
//    - standalone режим использует HashRouter, ему не нужен basename.
//    - В обычном режиме берем путь из window.FX_CONFIG или из переменной окружения как фолбэк.
const routerBasePath: string =
	VITE_APP_BUILD_MODE === "standalone"
		? "/"
		: (windowConfig.routerBasePath ?? VITE_APP_ROUTER_BASEPATH ?? BASE_URL ?? "/");

// 4. Определяем apiBasePath. Он также может быть динамическим.
// Сначала берем из конфига
// Потом берем из окружения
// Потом проверяем - а может у нас ассеты по полному пути берутся? тогда надо апи оттуда же брать
// Потом уже берем с текущего пути
const baseUrl = BASE_URL;
const locationOrigin = (typeof window !== 'undefined' && window.location && window.location.origin) ? window.location.origin : "";

const apiBasePath =
	windowConfig.apiBasePath ??
	(VITE_APP_API_BASE_PATH != null
		? VITE_APP_API_BASE_PATH
		: baseUrl.toLowerCase().startsWith("http")
			? // убираем трейлинг слеш
				baseUrl.replace(/\/+$/, "")
			: // Убирается трейлинг слеш
				`${locationOrigin}${routerBasePath}`.replace(/\/+$/, ""));

const routerType =
	windowConfig.routerType == null
		? VITE_APP_BUILD_MODE === "standalone"
			? "HashRouter"
			: "BrowserRouter"
		: windowConfig.routerType == "HashRouter"
			? "HashRouter"
			: "BrowserRouter";

const normalizedBaseUrl: string = routerBasePath !== "/" && routerBasePath !== "./" ? routerBasePath : "";

const game = windowConfig.game;
const forcedAdapter = windowConfig.forcedAdapter;

const supportedLocales = windowConfig.supportedLocales ?? hardcodedDefaultSupportedLocales;
const defaultLocale = windowConfig.defaultLocale ?? hardcodedDefaultLocale;

// 5. Экспортируем единый объект конфигурации
export const AppConfig: AppConfig = {
	game,
	forcedAdapter,
	routerBasePath,
	apiBasePath,
	routerType,
	normalizedBaseUrl,
	defaultLocale,
	supportedLocales
};

// export const routerBasePath =
// 	import.meta.env.VITE_APP_BUILD_MODE !== "standalone"
// 		? (import.meta.env.VITE_APP_ROUTER_BASEPATH ?? import.meta.env.BASE_URL)
// 		: undefined;
//
//
// // export const apiBasePath = import.meta.env.VITE_APP_API_BASE_PATH
// // 	? import.meta.env.VITE_APP_API_BASE_PATH
// // 	: `${window.location.origin}${normalizedBaseUrl}`;
//
// export const apiBasePath =
// 	import.meta.env.VITE_APP_API_BASE_PATH != null
// 		? import.meta.env.VITE_APP_API_BASE_PATH
// 		: normalizedBaseUrl.startsWith("http")
// 			? normalizedBaseUrl
// 			: `${window.location.origin}${normalizedBaseUrl}`;
